// API configuration with environment-aware fallback.
// Priority:
// 1) REACT_APP_API_BASE_URL if provided
// 2) Local PHP API when running on localhost
// 3) Production domain fallback
const isLocalhost =
	typeof window !== 'undefined' &&
	(window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const API_BASE_URL =
	process.env.REACT_APP_API_BASE_URL ||
	(isLocalhost ? 'http://localhost/alsadik' : 'https://al-sadik.com');
